/* eslint-disable no-unused-vars */
// Components
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  ClientAcquisition,
  InviteToFillForm,
  TherapistSolution,
} from "../components";
import { t } from "i18next";

const JoinOurNetworkPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    setSearchParams(
      { lang: localStorage.getItem("i18nextLng") },
      { replace: true },
    );
  }, [setSearchParams]);

  return (
    <>
      <Helmet>
        <title>{t("siteMap.joinOurNetwork.title")}</title>
        <meta
          name="description"
          content={t("siteMap.joinOurNetwork.description")}
        />
      </Helmet>
      <TherapistSolution />
      <ClientAcquisition />
      <InviteToFillForm getConsultation={false} />
    </>
  );
};

export default JoinOurNetworkPage;
